// reference: https://nehalist.io/working-with-models-in-angular/

export interface Deserializable {
    deserialize(input: any): this;
}

export class Deserializer implements Deserializable {
    constructor(response?: Object) {
        if (response)
            this.deserialize(response);
    }
    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/deserializable.model.ts